export enum MandateStatus {
  Unknown = 0,
  Created = 1,
  Pending = 2,
  Active = 3,
  Failed = 4,
  Revoked = 5,
}
